import { createContext, useState } from "react";

const MembershipContext = createContext({
    writeMembershipRefreshKey: 0,
    refreshWriteMembership: () => {},
});

export const MembershipProvider = ({ children }) => {
    const [writeMembershipRefreshKey, setWriteMembershipRefreshKey] = useState(0);

    const refreshWriteMembership = () => {
        setWriteMembershipRefreshKey((prev) => prev + 1);
    };

    return (
        <MembershipContext.Provider
            value={{ writeMembershipRefreshKey, refreshWriteMembership }}
        >
            {children}
        </MembershipContext.Provider>
    );
};

export default MembershipContext;
